/**
 * `/api/currency` — every call the currency module makes, through core's
 * `apiFetch`.
 */
import type {
  CurrencyListResponse,
  CurrencyLockResponse,
  CurrencyPreferenceResponse,
  CurrencyRateListResponse,
  ExchangeRateListResponse,
  ExchangeRateResponse,
  ImportRatesRequest,
  ImportRatesResponse,
  ListQueryParams,
  OkResponse,
  RateSourceListResponse,
} from '@forsys/shared';
import { apiFetch, query } from '../../api/client';

export const listCurrencies = () => apiFetch<CurrencyListResponse>('/currency/currencies');

export const getPreference = () => apiFetch<CurrencyPreferenceResponse>('/currency/preference');
export const setPreference = (displayCurrency: string | null) =>
  apiFetch<CurrencyPreferenceResponse>('/currency/preference', { method: 'PUT', json: { displayCurrency } });

export const listSources = () => apiFetch<RateSourceListResponse>('/currency/sources');
export const importRates = (body: ImportRatesRequest) =>
  apiFetch<ImportRatesResponse>('/currency/import', { method: 'POST', json: body });

export const listRateSummaries = () => apiFetch<CurrencyRateListResponse>('/currency/rates');
export const listRates = (currency: string, params: ListQueryParams = {}) =>
  apiFetch<ExchangeRateListResponse>(`/currency/rates/${encodeURIComponent(currency)}${query({ ...params })}`);
export const setRate = (currency: string, date: string, rate: string) =>
  apiFetch<ExchangeRateResponse>(`/currency/rates/${encodeURIComponent(currency)}/${date}`, {
    method: 'PUT',
    json: { rate },
  });
export const deleteRate = (currency: string, date: string) =>
  apiFetch<OkResponse>(`/currency/rates/${encodeURIComponent(currency)}/${date}`, { method: 'DELETE' });
export const setLocked = (currency: string, locked: boolean) =>
  apiFetch<CurrencyLockResponse>(`/currency/rates/${encodeURIComponent(currency)}/lock`, {
    method: 'PUT',
    json: { locked },
  });
